import { Component, OnInit } from "@angular/core";
import { ApiService } from "../../../services/api.service";
import {
    FormBuilder,
    FormGroup,
    FormControl,
    ReactiveFormsModule,
} from "@angular/forms";
import { ActivatedRoute } from "@angular/router";
import { NewsletterService } from "../../../services/newsletter.service";
import { HttpHeaders } from "@angular/common/http";

@Component({
    selector: "ngx-footer",
    styleUrls: ["./footer.component.scss"],
    templateUrl: "./footer.component.html",
    // template: `
    //  <span class="created-by">
    //     Created with ♥ by <b><a href="https://akveo.page.link/8V2f" target="_blank">Akveo</a></b> 2019
    //   </span>
    //   <div class="socials">
    //     <a href="#" target="_blank" class="ion ion-social-github"></a>
    //     <a href="#" target ="_blank" class="ion ion-social-facebook"></a>
    //     <a href="#" target="_blank" class="ion ion-social-twitter"></a>
    //     <a href="#" target="_blank" class="ion ion-social-linkedin"></a>
    //   </div>
    // `,
})
export class FooterComponent implements OnInit {
    firstName: string;
    lastName: string;
    email: string;
    constructor(
        private _api: ApiService,
        private fb: FormBuilder,
        private _activatedRoute: ActivatedRoute,
        private _newsletterService: NewsletterService
    ) {}
    mailchimpConfig: any;
    contractAddresss: string;

    ngOnInit(): void {
        this._activatedRoute.params.subscribe((res) => {
            console.log(res);
            if (res.contractAddress) {
                this.contractAddresss = res.contractAddress;
                this._newsletterService
                    .getNewsletterConfig(res.contractAddress)
                    .subscribe(
                        (res) => {
                            console.log(res);
                            this.mailchimpConfig = res;
                        },
                        (err) => {
                            this.mailchimpConfig = null;
                        }
                    );
            }
        });
    }

    subscribe = async () => {
        // console.log(email);
        this._newsletterService
            .addSubscriberToNewsletter(this.contractAddresss, this.email)
            .subscribe((res) => {
                console.log(res);
            });
    };
}
